import React, { useContext, useState } from 'react';

import Context from '../../../store/context';
import Button from '../../Buttons/Button/Button';
import LabelField from '../../Fields/LabelField/LabelField';
import TextInput from '../../inputs/TextInput/TextInput';
import DropFiles from '../DropFiles/DropFiles';

import classes from './FormFiles.module.scss';

const FormImg = ({ files, onChange }) => {
  const [idxFile, setIdxFile] = useState(0);
  const [filesForm, setFilesForm] = useState(files);

  const {
    modal: { hideModal }
  } = useContext(Context);

  const setFile = (key, value) => {
    setFilesForm(filesForm => {
      const auxFiles = [...filesForm];
      auxFiles[idxFile] = { ...auxFiles[idxFile], [key]: value };
      return auxFiles;
    });
  };
  const saveFiles = key => {
    if (!key) {
      setIdxFile(idx => idx + 1);
    } else {
      onChange(filesForm);
      hideModal();
    }
  };
  const changeOtherFiles = file => {
    const [extension] = file.name.split('.').slice(-1);
    const [name] = file.name.split('.').slice(0);
    setFilesForm(filesForm => {
      const auxFiles = [...filesForm];
      auxFiles[idxFile] = { ...auxFiles[idxFile], extension, name, description: '', dropFile: file };
      return auxFiles;
    });
  };

  const positionFile = idxFile + 1 === filesForm.length;

  return (
    <div className={classes.form}>
      <span>{`${idxFile + 1} archido de: ${filesForm.length}`} </span>
      {filesForm.length !== 0 && <span>{`${filesForm[idxFile].name}.${filesForm[idxFile].extension}`}</span>}
      {files[idxFile].file && (
        <DropFiles name='newFile' onDroppedFiles={files => changeOtherFiles(files[0])}>
          <Button>Cambiar archivo</Button>
        </DropFiles>
      )}
      {filesForm.length !== 0 && (
        <>
          <LabelField label='Nombre'>
            <TextInput name={`${idxFile}.name`} value={filesForm[idxFile].name} onChange={value => setFile('name', value)} />
          </LabelField>
          <LabelField label='Descripción'>
            <TextInput
              name={`${idxFile}.description`}
              value={filesForm[idxFile].description}
              onChange={value => setFile('description', value)}
            />
          </LabelField>

          <Button onClick={() => saveFiles(positionFile)}>{positionFile ? 'Guardar' : 'Siguiente'}</Button>
        </>
      )}
    </div>
  );
};

export default FormImg;
